import { Logo, XButton } from '#assets/svg';
import { KakaoButton } from '#molecules';

interface Props {
  onClose: () => void;
  kakaoLogin: () => void;
}

const TrainerCommunityOauthModal = ({ onClose, kakaoLogin }: Props) => {
  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex flex-col gap-48">
        <div className="flex flex-col gap-40">
          <div className="flex flex-col gap-12">
            <div className="flex items-center justify-between w-full">
              <Logo width={50} height={16} />
              <XButton onClick={onClose} />
            </div>
          </div>
          <h1 className="text-center">
            지금 트뮤니티 멤버가 되어
            <br />한 단계 성장해 보세요
          </h1>
        </div>
        <div className="flex flex-col gap-[13.5px]">
          <KakaoButton
            text="카카오로 3초만에 시작하기"
            icon
            onClick={kakaoLogin}
          />
        </div>
      </div>
    </div>
  );
};

export default TrainerCommunityOauthModal;
